
export const MAX_ANIMATION_LAYER = 32;
